import { API_AUTH } from "./common";

const LogActivities = {
    ClientActivityModules: (url) =>
        API_AUTH.post(
            `he-thong/ghi-nhan-truy-cap?url=${url}`,
            {},
        ),
};

export default LogActivities;
